import { faWarning } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { FunctionComponent } from 'react'

import useStyles from './WarningBox.styles'

export interface WarningBoxProps {
  children: React.ReactNode
}

const WarningBox: FunctionComponent<WarningBoxProps> = ({ children }) => {
  const classes = useStyles()
  return (
    <div className={classes.tipBox}>
      <span className={classes.tipBoxIcon}>
        <FontAwesomeIcon icon={faWarning} fade />
      </span>
      {children}
    </div>
  )
}

export default WarningBox
